import * as basicLightbox from "basiclightbox";

(function () {
    let modal_instance;

    document.querySelectorAll("[data-lightbox]").forEach((item) => {
        item.addEventListener("click", (event) => {
            event.preventDefault();
            modal_instance = basicLightbox.create(document.querySelector(event.target.getAttribute("data-lightbox")));
            modal_instance.show(() => {
                modal_instance
                    .element()
                    .querySelector("[data-close]")
                    .addEventListener("click", () => {
                        modal_instance.close();
                    });
            });
        });
    });
})();
